<template>
  <v-dialog
    v-model="isOpenModal"
    :scrim="false"
    scrollable
    persistent
    fullscreen
    :transition="$vuetify.breakpoint.mobile ? 'dialog-bottom-transition' : 'slide-x-transition'"
  >
    <v-card
      class="border-radius-0"
      :class="$vuetify.breakpoint.mobile ? 'help-card-mobile' : ''"
      :height="$vuetify.breakpoint.mobile ? '' : '100%'"
    >
      <div class="d-flex bg-titre">
        <div class="secondary--text align-self-center pl-3 titre-h3 mr-auto">
          {{ titreFormatted }}
        </div>
        <v-btn
          text
          class="align-self-center"
          @click="close"
        >
          <v-icon color="secondary">
            mdi-close
          </v-icon>
        </v-btn>
      </div>
      <slot name="baseCardHelpContent" />
    </v-card>
  </v-dialog>
</template>

<script>
import capitalize from '@/filters/string.filter'

export default {
  name: 'RechercheAdherentModal',
  props: {
    titre: {
      type: String,
      default: 'Information'
    },
    isOpenModalRechercheAdherent: {
      type: Boolean,
      default:false
    }
  },
    data () {
    return {
      isOpenModal: false
    }
  },
  computed: {
    titreFormatted (){
      return capitalize.capitalize(this.titre)
    }
  },
  created () {
    this.isOpenModal = this.isOpenModalRechercheAdherent
  },

  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}
.border-radius-0 {
  border-radius: 0px !important;
}
</style>